import { makeRequest } from './https';
import { 
  NotificationsResponseSchema, 
  AddNotificationSchema, 
  AddNotificationToUsersRequest,
  UpdatePlayerIdRequest,
  GetNotificationsParams 
} from '../types/notification.type';

export const getMyOrganizationNotifications = async (params?: {
  limit?: number;
  offset?: number;
  unread_only?: boolean;
}): Promise<NotificationsResponseSchema> => {
  return makeRequest({
    url: '/notification/my-organizations',
    method: 'get',
    params: {
      limit: params?.limit ?? 20,
      offset: params?.offset ?? 0,
      unread_only: params?.unread_only ?? true,
    },
  });
};

export const getNotifications = async (params: GetNotificationsParams): Promise<NotificationsResponseSchema> => {
  const { organization_id, limit = 10, before_message_id, after_message_id } = params;
  
  const requestParams: any = { limit };
  
  if (before_message_id) {
    requestParams.before_message_id = before_message_id;
  }
  
  if (after_message_id) {
    requestParams.after_message_id = after_message_id;
  }

  return makeRequest({
    url: `/notification/${organization_id}`,
    method: 'get',
    params: requestParams,
  });
};

export const addNotification = async (data: AddNotificationSchema): Promise<void> => {
  return makeRequest({
    url: '/notification',
    method: 'post',
    data,
  });
};

export const addNotificationToUsers = async (
  data: AddNotificationToUsersRequest,
  params: {
    title_en: string;
    title_ar: string;
    message_en: string;
    message_ar: string;
    organization_id: string;
  }
): Promise<void> => {
  const requestParams = {
    title_en: params.title_en,
    title_ar: params.title_ar,
    message_en: params.message_en,
    message_ar: params.message_ar,
    organization_id: params.organization_id,
  };

  return makeRequest({
    url: '/notification/users',
    method: 'post',
    data,
    params: requestParams,
  });
};

export const updatePlayerId = async (data: UpdatePlayerIdRequest): Promise<void> => {
  return makeRequest({
    url: '/notification/player-id',
    method: 'put',
    params: { player_id: data.player_id },
  });
};

export const markNotificationAsRead = async (organization_id: string, notification_id: string): Promise<void> => {
  return makeRequest({
    url: `/notification/${organization_id}/${notification_id}/read`,
    method: 'put',
  });
}; 